import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Enabled from '@/components/Enabled/index.vue';
let default_1 = class default_1 extends Vue {};
__decorate([Prop({
  default: {}
})], default_1.prototype, "data", void 0);
default_1 = __decorate([Component({
  name: 'LedgerUserTab',
  components: {
    Enabled
  }
})], default_1);
export default default_1;